import React, {useEffect} from 'react';
import { IconVisitorManagementDesign } from '../../../../components/buttons/IconButtons';
import FullPageLoader from '../../../../utils/FullPageLoader';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param boolean loading: For loading page (required)
 * @param event handleSave: event to save data (required)
 * @param string title: title for section (required)
 * @param string subtitle: subtitle for section (required)
 */
const SubmittingIdCard = (
    {
        loading,
        handleSave,
        title,
        subtitle
    }
) => {

    useEffect(() => {
        if(handleSave) {
            handleSave();
        }
    }, []);

    return (
        <>
            {loading
                ?
                <FullPageLoader className="background-linear-gradient-950-opacity025"/>
                :
                <>
                    <div className="d-flex flex-column gap-3">
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{title}</p>
                        <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{subtitle}</p>
                    </div>

                    <div className="d-flex justify-content-center align-items-center pt-2">
                        <div className="icon-submitting-validation-container">
                            <IconVisitorManagementDesign className="w-100 h-100" />
                        </div>
                    </div>
                </>
            }
        </>
    )

}

export default SubmittingIdCard
